import React from "react";
const ACTION_PLAN_IMAGE = "https://cdn.magicpatterns.com/uploads/hD27iDwCKUpmK9PVytQk8E/Bono_4_Collage_Plan_30_Dias.webp";
export function ActionPlanPreview() {
  return <div className="overflow-hidden rounded-xl bg-cream-50 ring-1 ring-cocoa-900/10" data-id="element-71" data-mp="2jlcc5iuq5dtq">
      <img src={ACTION_PLAN_IMAGE} alt="Plan de acción de 30 días: portada, mapa de los 30 días y hojas prácticas por semana" width={1568} height={1137} loading="lazy" className="block h-auto w-full" data-id="element-72" data-mp="2jiznkmugo57p" />
    </div>;
}